import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import SignUpForm from './SignUpForm/SignUpForm';
import SignInForm from './SignInForm/SignInForm';

const Container = styled('div')`
  display: flex;
`;

class Auth extends React.Component {
  render() {
    return (
      <Container>
        <Route exact path="/auth" component={SignInForm} />
        <Route path="/auth/signUp" component={SignUpForm} />
      </Container>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/views/Auth/Auth.js